import React, { useContext, useEffect } from 'react'
import {
    Stack, Card, CardContent, Typography,
    Accordion, AccordionSummary, AccordionDetails, Badge, CardHeader
} from "@mui/material";
import { AnomaliesContext } from '../contexts';
import { AnomaliesTables } from "../components";
import { ExpandMore } from '@mui/icons-material';
import { useDictionary, useEventTypes } from "../hooks";

const AnomaliesUsersStatus = () => {
    const {
        state: { usersAnomalies },
        setUsersAnomalies,
    } = useContext(AnomaliesContext);
    const types = useEventTypes();

    useEffect(() => {
        setUsersAnomalies();
    }, []);

    const dictionary = useDictionary();

    const orderedAnomalies = [];
    usersAnomalies.map(anomaly => {
        let key = `${anomaly.firstname.trim()} ${anomaly.lastname.trim()}`;
        if (!orderedAnomalies[key]) {
            orderedAnomalies[key] = [];
        }
        orderedAnomalies[key]?.push(anomaly);
    });

    return (
        <Stack spacing={2}>
            <Card>
                <CardHeader title={dictionary["routes"]["anomaliesToBeJustified"]} />
                <CardContent>
                    {Object.entries(orderedAnomalies).map((item, index) => (
                        <Accordion key={`${item[0]}-${index}`}>
                            <AccordionSummary
                                expandIcon={<ExpandMore />} >
                                <Typography variant="outlined">
                                    {item[0]}
                                </Typography>
                                <Badge badgeContent={item[1].length} color={"anomalies"} sx={{ marginLeft: "15px" }} />
                            </AccordionSummary>
                            <AccordionDetails>
                                <AnomaliesTables
                                    mini={false}
                                    onlyView={true}
                                    searchedAnomalies={item[1]}
                                    types={types}
                                />
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </CardContent>
            </Card>
        </Stack >
    )
}

export default AnomaliesUsersStatus